<template>
    <div v-show=load :id="name" class="px-2 ma-n4" :ref="name" style="height: 300px"></div>
</template>

<script>

    import * as am4core from '@amcharts/amcharts4/core'
    import * as am4charts from '@amcharts/amcharts4/charts'
    import am4themes_dark from '@amcharts/amcharts4/.internal/themes/dark'
    import am4themes_material from '@amcharts/amcharts4/themes/material'
    import am4themes_animated from "@amcharts/amcharts4/themes/animated"
    
    am4core.useTheme(am4themes_animated)

    export default {
        name: 'campaign-kpi',

        props: {
            name: String,
            category: String,
            counter: Number,
            total: Number,
            colorIndex: Number,
        },

        data() {
            return {
                load: false,
                chart: {},
            }
        },

        methods: {

            initialize() {

                this.chart = am4core.create(this.name, am4charts.RadarChart)
                this.chart.data = [{
                    "category": this.category,
                    "value": this.counter,
                    "full": this.total == 0 ? 1 : this.total
                }];
                
                let percentage = this.counter == 0 ? '(0%)' : '('+((this.counter * 100) / (this.total == 0 ? 1 : this.total)).toFixed(0)+')%'

                // Make chart not full circle
                this.chart.startAngle = -89
                this.chart.endAngle = 270
                this.chart.innerRadius = am4core.percent(75)

                // Create axes
                let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())
                categoryAxis.dataFields.category = "category"
                categoryAxis.renderer.labels.template.disabled = true
                categoryAxis.renderer.grid.template.location = 0
                categoryAxis.renderer.grid.template.strokeOpacity = 0
                categoryAxis.renderer.minGridDistance = 10

                let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis())
                valueAxis.renderer.grid.template.strokeOpacity = 0
                valueAxis.min = 0
                valueAxis.max = this.total == 0 ? 1 : this.total
                valueAxis.strictMinMax = true
                valueAxis.renderer.labels.template.disabled = true

                var centerLabel1 = this.chart.radarContainer.createChild(am4core.Label)
                centerLabel1.fontSize = 54
                centerLabel1.horizontalCenter = 'middle'
                centerLabel1.verticalCenter = 'middle'
                centerLabel1.dy = -10
                centerLabel1.dx = 0
                centerLabel1.text = this.counter
                centerLabel1.fill = am4core.color('#00E676')

                var centerLabel2 = this.chart.radarContainer.createChild(am4core.Label)
                centerLabel2.fontSize = 16
                centerLabel2.horizontalCenter = 'middle'
                centerLabel2.marginTop = 0
                centerLabel2.dy = 15
                centerLabel2.text = "[bold]"+ percentage + "[/]"
                centerLabel2.fill = am4core.color('#00E676')

                // Create series
                var series1 = this.chart.series.push(new am4charts.RadarColumnSeries());
                series1.dataFields.valueX = 'full'
                series1.dataFields.categoryY = "category";
                series1.clustered = false;
                series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
                series1.columns.template.fillOpacity = 0.08;
                series1.columns.template.cornerRadiusTopLeft = 20;
                series1.columns.template.strokeWidth = 0;
                series1.columns.template.radarColumn.cornerRadius = 20;

                let series2 = this.chart.series.push(new am4charts.RadarColumnSeries())
                series2.dataFields.valueX = 'value'
                series2.dataFields.categoryY = 'category'
                series2.clustered = false
                series2.columns.template.strokeWidth = 0
                series2.columns.template.tooltipText = "{category}: [bold]{value}[/]";
                series2.columns.template.radarColumn.cornerRadius = 20

                series2.columns.template.adapter.add("fill", (fill, target) => {
                    return this.chart.colors.getIndex(this.colorIndex)
                })

                
                this.load = true
                this.$store.commit('endProgress')

            },
        },

        mounted() {
            this.initialize()
        },

        beforeDestroy() {
            if (this.chart && !_.isEmpty(this.chart)) {
                this.chart.dispose()
            }
        },
    }
</script>

<style>

</style>